<span #iconElement><i #icon class="fa fa-warning"></i></span>

<bb-tooltip #tooltip [contents]="contents" [targetElement]="element"></bb-tooltip>
